import { useTranslation } from "react-i18next";
import LinkWrapper from "../../../../elements/link-wrapper/link-wrapper";
import { THeaderV2Props } from "../../header-v2";
import MobileFeaturedLink from "../mobile-featured-link/mobile-featured-link";
import MobileMenuActionBar from "../mobile-menu-action-bar/mobile-menu-action-bar";
import styles from "./mobile-first-level-menu.module.less";
import { isArrayWithItems } from "../../../../../helpers/array-helper";

type TMobileFirstLevelMenuProps = Omit<THeaderV2Props, "logoUrl"> & {
  onClickClose: () => void;
  onClickCategory: (index: number) => void;
};

const MobileFirstLevelMenu = ({
  menuItems,
  featureLinks,
  onClickCategory,
  onClickClose,
}: TMobileFirstLevelMenuProps) => {
  const { t } = useTranslation();

  return (
    <div className={styles.wrapper}>
      <div className={styles.innerWrapper}>
        <div className={styles.topItemsWrapper}>
          <LinkWrapper
            className={[styles.topMenuLink, "h3 mb-0"].join(" ")}
            key={-1}
            url={"/"}
            title={t("HEADER_HOME")}
          />
          {menuItems.map((item, index) => {
            if (isArrayWithItems(item.links)) {
              return (
                <button onClick={() => onClickCategory(index)} key={index} className={styles.topMenuItem}>
                  <div className={"h3 mb-0"}>{item.title}</div>
                  <span className={[styles.topMenuItemIcon, "ui-icon-arrow-right bold"].join(" ")} />
                </button>
              );
            }

            return (
              <LinkWrapper
                className={[styles.topMenuLink, "h3 mb-0"].join(" ")}
                key={index}
                url={item.url}
                title={item.title}
              />
            );
          })}
        </div>
        <div className={styles.featureLinksWrapper}>
          {featureLinks.map((featureLink, index) => {
            return <MobileFeaturedLink key={index} {...featureLink} />;
          })}
        </div>
      </div>
      <MobileMenuActionBar onClickClose={onClickClose} />
    </div>
  );
};

export default MobileFirstLevelMenu;
